import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioRoutingModule } from './radio-routing.module';
import { RadioButtonComponent } from './radioButton.component';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {RadioButtonModule} from "../../component/ing/radiobutton/radiobutton";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RadioRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    RadioButtonModule,
    TableModule
  ],
  declarations: [
  	RadioButtonComponent
  ]
})
export class RadioButtonDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/radioButton/radioButtonDemo.module.ts